import { GlobalRouter } from "@routes/index";
import ChatAI from "@assets/KPMG/ChatAI.png";
import "@styles/index.scss";
import "antd/dist/antd.less";
import { useContext, useEffect, useState } from "react";
import { useAuth } from "./Hooks/useAuth";
import { Drawer, Modal } from "antd";
import { useLocation } from "react-router-dom";
import { ChatWindow } from "@modules/KnowledgeHub/ChatWindow";

function App() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {}, [user]);

  return (
    <>
      {!["/auth/login", "/auth/signup", "/verify-email"].includes(pathname) && (
        <div onClick={() => setOpen(true)} className="chat-ref">
          <img src={ChatAI} className="chat-icon" />
        </div>
      )}
      <Drawer
        title="KPMG KymChat"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
        size={"large"}
      >
        <div className="chatbox-content">
          <ChatWindow />
        </div>
      </Drawer>
      <GlobalRouter />
    </>
  );
}

export default App;
